import { partial } from 'radash';

import { Synchronizable, SyncProcess, update, updateInProgress } from './Synchronizable';
import { Success, toFailed } from './SyncResult';
import { Done, idle, isInProgress } from './SyncState';

export async function synchronize(
  synchronizable: Synchronizable,
  syncProcess: SyncProcess,
): Promise<Success> {
  if (isInProgress(synchronizable.syncState)) return synchronizable.syncState.promise;

  const goalResolvers = Promise.withResolvers<Success>();
  try {
    const progress = partial(updateInProgress, synchronizable, goalResolvers.promise, new Date());
    progress('Starting Sync');

    const result = await syncProcess(progress);

    const done: Done = {
      asOf: new Date(),
      description: idle,
      result,
    };
    update(synchronizable, done);
    goalResolvers.resolve(result);
  } catch (error) {
    const result = toFailed(error);
    const done: Done = {
      asOf: new Date(),
      description: idle,
      result,
    };
    update(synchronizable, done);
    goalResolvers.reject(result);
  }

  return goalResolvers.promise;
}
